import React from 'react';
import { Handshake } from 'lucide-react';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/auction-card-real-estate.scss';
import { AuctionIcon, BuildingIcon } from '../../../../common/icons';
import { OnlineAuction } from './AuctionsCategory/OnlineAuction';
import { RealEstate } from './AuctionsCategory/RealEstate';
import { DirectSale } from './AuctionsCategory/DirectSale';

const VALID_TYPES = ['auctions', 'direct_sale', 'real_estate'];
const DEFAULT_TYPE = 'auctions';

class AuctionSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeType: this.getTypeFromURL(),
      fadeIn: true,
    };
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handlePopState);

    // Set default query if none exists
    const params = new URLSearchParams(window.location.search);
    if (!params.get('type')) {
      const url = new URL(window.location);
      url.searchParams.set('type', DEFAULT_TYPE);
      window.history.replaceState({}, '', url);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = () => {
    this.setState({ activeType: this.getTypeFromURL() });
  };

  getTypeFromURL() {
    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    return VALID_TYPES.includes(type) ? type : DEFAULT_TYPE;
  }

  switchType(type) {
    if (type === this.state.activeType) return;
    this.setState({ fadeIn: false });
    setTimeout(() => {
      // Set new type, clear stale filter params
      const url = new URL(window.location);
      url.searchParams.set('type', type);
      url.searchParams.delete('timeFilter');
      url.searchParams.delete('category');
      url.searchParams.delete('sort');
      window.history.pushState({}, '', url);

      this.setState({ activeType: type, fadeIn: true });
    }, 180);
  }

  render() {
    const { activeType, fadeIn } = this.state;

    return (
      <section className="as-section" style={{ backgroundColor: '#F2F2F2' }}>
        <div className="container-fluid">

          {/* ── Type Switcher ── */}
          <div className="as-type-switcher">
            <button
              className={`as-type-btn ${activeType === 'real_estate' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
              onClick={() => this.switchType('real_estate')}
            >
              <BuildingIcon width={26} height={26} />
              {i18n.t('real_estate_auctions') || 'Real Estate Auctions'}
            </button>
            <button
              className={`as-type-btn ${activeType === 'auctions' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
              onClick={() => this.switchType('auctions')}
            >
              <AuctionIcon width={26} height={26} />
              {i18n.t('online_auctions') || 'Auctions'}
            </button>
            <button
              className={`as-type-btn ${activeType === 'direct_sale' ? 'as-type-btn--active' : 'as-type-btn--inactive'}`}
              onClick={() => this.switchType('direct_sale')}
            >
              <Handshake width={26} height={26} />
              {i18n.t('direct_sale') || 'Direct Sale'}
            </button>
          </div>

          {/* ── Content ── */}
          <div className={`as-content-area ${fadeIn ? 'as-fade-visible' : 'as-fade-enter'}`}>
            {activeType === 'auctions' && <OnlineAuction type="auctions" />}
            {activeType === 'direct_sale' && <DirectSale type="direct_sale" />}
            {activeType === 'real_estate' && <RealEstate type="real_estate" />}
          </div>

        </div>
      </section>
    );
  }
}
export default AuctionSwitcher;
